(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["takebag-combo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takebag-combo-offer')) {
    class TakebagComboOffer extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.data = JSON.parse(this.querySelector('[data-combo-data]').textContent);
        this.mainForm = document.getElementById(this.dataset.mainForm);
        this.select = this.querySelector('[data-companion-variant]');
        this.button = this.querySelector('[data-combo-submit]');
        this.update = () => this.refresh();
        this.select.addEventListener('change',this.update,{signal:this.events.signal});
        document.addEventListener('variant:changed',this.update,{signal:this.events.signal});
        this.refresh();
      }
      disconnectedCallback() { this.events?.abort(); this.events = null; }
      refresh() {
        const mainId = this.mainForm?.querySelector('[name="id"]')?.value;
        const main = this.data.main.find(v => v.id === mainId) || this.data.main[0];
        const companion = this.data.companion.find(v => v.id === this.select.value);
        if (!main || !companion) return;
        const colors = this.dataset.mainBag === 'true' ? [main.color,companion.color] : [companion.color,main.color];
        const combo = this.data.combo.find(v => v.colors[0] === colors[0] && v.colors[1] === colors[1]);
        const save = combo ? main.price+companion.price-combo.price : 0;
        this.button.disabled = !combo?.available || save <= 0;
        this.querySelector('[data-combo-id]').value = combo?.id || '';
        this.querySelector('[data-saving-label]').hidden = save <= 0;
        const format = value => new Intl.NumberFormat(this.dataset.locale || 'pt-BR',{style:'currency',currency:this.dataset.currency || 'BRL'}).format(value/100);
        this.querySelector('[data-original-price]').textContent = format(companion.price);
        this.querySelector('[data-companion-price]').textContent = combo ? format(combo.price-main.price) : '—';
        this.querySelector('[data-combo-price]').textContent = combo ? format(combo.price) : '—';
        this.querySelector('[data-saving-label]').textContent = this.dataset.saving+' '+format(save);
        const image = this.querySelector('.tb-combo__image');
        image.src = companion.image;
        image.removeAttribute('srcset');
        this.querySelectorAll('[data-companion-link]').forEach(link => link.href = companion.url);
      }
    }
    customElements.define('takebag-combo-offer',TakebagComboOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["takebag-drawer-combo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takebag-drawer-combo')) {
  class TakebagDrawerCombo extends HTMLElement {
    connectedCallback() {
      if(this.events)return;
      this.events=new AbortController();
      this.data=JSON.parse(this.querySelector('[data-options]').textContent);
      this.select=this.querySelector('[data-color]');this.button=this.querySelector('[data-upgrade]');this.status=this.querySelector('[data-status]');
      this.select.addEventListener('change',()=>this.refresh(),{signal:this.events.signal});
      this.button.addEventListener('click',()=>this.upgrade(),{signal:this.events.signal});
      this.refresh();
    }
    disconnectedCallback(){this.events?.abort();this.events=null;}
    money(value){return new Intl.NumberFormat(this.dataset.locale||'pt-BR',{style:'currency',currency:this.dataset.currency||'BRL'}).format(value/100);}
    selection(){const bottle=this.data.bottles.find(v=>v.id===this.select.value);return {bottle,combo:this.data.combos.find(v=>v.colors[0]===this.dataset.bagColor&&v.colors[1]===bottle?.color)};}
    refresh(){
      const {bottle,combo}=this.selection();if(!bottle)return;
      const extra=combo?combo.price-Number(this.dataset.bagPrice):0,additionalSaving=bottle.price-extra;
      const saving=combo?Number(this.dataset.bagReference)+Number(bottle.reference||bottle.price)-combo.price:0;
      this.button.disabled=!combo?.available||!bottle.available||additionalSaving<=0;
      this.querySelector('[data-original]').textContent=this.money(bottle.price);
      this.querySelector('[data-extra]').textContent=combo?this.money(extra):'—';
      this.querySelector('[data-total]').textContent=combo?this.money(combo.price):'—';
      this.querySelector('[data-saving]').textContent=this.dataset.saving+' '+this.money(Math.max(0,saving));
      this.querySelector('.tb-drawer-combo__image').src=bottle.image;this.querySelector('.tb-drawer-combo__image').removeAttribute('srcset');
      this.button.textContent=this.button.disabled?this.dataset.unavailable:bottle.inCart>0?this.dataset.apply:this.dataset.add+' '+this.money(extra);
      this.status.textContent='';
    }
    async request(path,body){
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),25000);
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{'Content-Type':'application/json',Accept:'application/json'},body:body?JSON.stringify(body):undefined,signal:controller.signal});
        const data=await response.json();if(!response.ok)throw new Error(this.dataset.failed);return data;
      }finally{clearTimeout(timer);}
    }
    plain(item){return !item.selling_plan_allocation&&!Object.keys(item.properties||{}).length;}
    publish(cart){
      if(!cart.sections?.['mini-cart'])delete cart.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart,openMiniCart:true,replacementDelay:0}}));
    }
    async upgrade(){
      if(this.button.disabled||window.TakebagCartMutation)return;
      const {bottle,combo}=this.selection();if(!combo?.available)return;
      const drawer=this.closest('cart-drawer'),footer=drawer?.querySelector('footer'),form=drawer?.querySelector('#mini-cart-form');
      this.button.disabled=true;this.select.disabled=true;this.status.textContent=this.dataset.loading;this.setAttribute('aria-busy','true');
      if(footer)footer.inert=true;if(form)form.inert=true;
      const task=(async()=>{
        const cart=await this.request('cart.js');
        const bag=cart.items.find(item=>item.key===this.dataset.bagKey&&String(item.variant_id)===this.dataset.bagId&&item.quantity>0&&this.plain(item));
        if(!bag){this.publish(cart);throw new Error(this.dataset.changed);}
        const catalog=await this.request('products/combo-3-bag-garrafa.js');
        const actual=catalog.variants.find(v=>String(v.id)===combo.id);
        if(!actual?.available||actual.price!==combo.price||bag.final_price!==Number(this.dataset.bagPrice))throw new Error(this.dataset.changed);
        const existingBottle=cart.items.find(item=>String(item.variant_id)===bottle.id&&this.plain(item));
        const existingCombo=cart.items.find(item=>String(item.variant_id)===combo.id&&this.plain(item));
        const updates={[bag.key]:bag.quantity-1,[existingCombo?.key||combo.id]:(existingCombo?.quantity||0)+1};
        if(existingBottle)updates[existingBottle.key]=existingBottle.quantity-1;
        const result=await this.request('cart/update.js',{updates,sections:['mini-cart'],sections_url:location.pathname});
        this.status.textContent=this.dataset.success;
        this.publish(result);
        return result;
      })();
      window.TakebagCartMutation=task;
      try{await task;}catch(error){this.status.textContent=error.name==='AbortError'?this.dataset.failed:error.message;this.button.disabled=false;}
      finally{if(window.TakebagCartMutation===task)window.TakebagCartMutation=null;if(footer)footer.inert=false;if(form)form.inert=false;this.select.disabled=false;this.removeAttribute('aria-busy');}
    }
  }
  customElements.define('takebag-drawer-combo',TakebagDrawerCombo);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["takebag-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takebag-product-delivery')) {
    class TakebagProductDelivery extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.sequence = 0;
        this.zip = this.querySelector('[data-zip]');
        this.button = this.querySelector('[data-calculate]');
        this.status = this.querySelector('[data-status]');
        this.rates = this.querySelector('[data-rates]');
        this.form = document.getElementById(this.dataset.formId);
        this.variantKey = this.selectionKey();
        const options = { signal: this.events.signal };
        this.zip.addEventListener('input', () => { const d = this.zip.value.replace(/\D/g, '').slice(0,8); this.zip.value = d.length > 5 ? d.slice(0,5)+'-'+d.slice(5) : d; this.clear(); }, options);
        this.zip.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); this.calculate(); } }, options);
        this.button.addEventListener('click', () => this.calculate(), options);
        this.zip.addEventListener('input', () => { clearTimeout(this.autoTimer); if(this.zip.value.replace(/\D/g,'').length===8)this.autoTimer=setTimeout(()=>this.calculate(),450); },options);
        this.onSelection = () => { const next = this.selectionKey(); if (next !== this.variantKey) { this.variantKey = next; this.clear(this.dataset.changed); } };
        document.addEventListener('variant:changed', this.onSelection, options);
        document.addEventListener('change', this.onSelection, options);
        this.onDestination = event => {
          const destination = event.detail;
          if (!destination || destination.source === this || destination.zip === this.zip.value.replace(/\D/g,'')) return;
          this.clear();
          this.zip.value = destination.zip.slice(0,5)+'-'+destination.zip.slice(5);
        };
        document.addEventListener('takebag:destination-changed', this.onDestination, options);
        document.addEventListener('takebag:delivery-choice',event=>{
          if(event.detail?.zip!==this.zip.value.replace(/\D/g,''))return;
          const choice=window.TakebagDelivery?.preference(event.detail.zip);
          const chosen=this.displayedRates?.find(rate=>window.TakebagDelivery.match(rate,choice));
          if(chosen){const amount=chosen.price===0?this.dataset.freeLabel:new Intl.NumberFormat(this.dataset.locale||'pt-BR',{style:'currency',currency:this.dataset.currency||'BRL'}).format(chosen.price);this.querySelector('[data-delivery-heading]').textContent=chosen.name+' · '+amount;this.status.textContent=this.dataset.selected+' · CEP '+this.zip.value;}
          this.rates.querySelectorAll('li').forEach(row=>{const radio=row.querySelector('input');if(radio){radio.checked=radio.parentElement.querySelector('span').textContent===choice?.name;row.dataset.selected=String(radio.checked);}});
        },options);
        try {
          const destination = JSON.parse(sessionStorage.getItem('takebag.delivery.destination.v1') || 'null');
          const remembered = JSON.parse(sessionStorage.getItem('takebag.delivery.product.v2') || 'null');
          if (destination?.zip) this.zip.value = destination.zip.slice(0,5)+'-'+destination.zip.slice(5);
          if (remembered && Date.now()-remembered.at < 300000 && (!destination || destination.zip === remembered.zip.replace(/\D/g,''))) {
            this.zip.value = remembered.zip;
            if (remembered.key === this.variantKey && remembered.rates.every(rate=>rate.handle)) this.show(remembered.rates, remembered.zip);
          }
        } catch (_) {}
      }
      disconnectedCallback() { clearTimeout(this.autoTimer); this.sequence++; this.controller?.abort(); this.events?.abort(); this.events = null; }
      selection() { return { id: this.form?.querySelector('[name="id"]')?.value || this.dataset.variant, quantity: Math.max(1, Number(this.form?.elements.namedItem('quantity')?.value) || 1) }; }
      selectionKey() { return JSON.stringify(this.selection()); }
      clear(message = '') { this.querySelector('[data-address-preview]')?.remove(); this.sequence++; this.controller?.abort(); this.rates.replaceChildren(); this.rates.hidden = true; this.status.textContent = message; this.button.disabled = false; this.removeAttribute('aria-busy'); this.removeAttribute('data-free'); this.querySelector('[data-delivery-heading]').textContent = this.dataset.title; }
      province(zip) {
        const n = Number(zip.slice(0,5));
        const ranges = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],[72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
        return ranges.find(([a,b]) => n >= a && n <= b)?.[2];
      }
      async storefront(query, variables) {
        const response = await fetch(this.dataset.endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'multipart/mixed; deferSpec=20220824, application/json' }, body: JSON.stringify({ query, variables }), signal: this.controller.signal });
        if (!response.ok) throw new Error(this.dataset.failed);
        const body = await response.text();
        const type = response.headers.get('content-type') || '';
        if (!type.includes('multipart/mixed')) return [JSON.parse(body)];
        const boundary = type.match(/boundary="?([^";\s]+)"?/)?.[1];
        if (!boundary) throw new Error(this.dataset.failed);
        return body.split('--'+boundary).map(part => { const start = part.indexOf('{'), end = part.lastIndexOf('}'); return start >= 0 && end >= start ? JSON.parse(part.slice(start,end+1)) : null; }).filter(Boolean);
      }
      async calculate() {
        if (this.button.disabled) return;
        this.clear();
        const zip = this.zip.value.replace(/\D/g,'');
        const provinceCode = this.province(zip);
        if (!/^\d{8}$/.test(zip) || /^(\d)\1{7}$/.test(zip) || !provinceCode) { this.status.textContent = this.dataset.invalid; this.zip.focus(); return; }
        const selection = this.selection(), key = JSON.stringify(selection), sequence = this.sequence;
        this.controller = new AbortController();
        const controller = this.controller;
        const timeout = setTimeout(() => controller.abort(), 35000);
        this.button.disabled = true;
        this.setAttribute('aria-busy','true');
        this.status.textContent = this.dataset.loading;
        try {
          const create = 'mutation TakebagProductQuote($input: CartInput!) { cartCreate(input: $input) { cart { id } userErrors { field message } } }';
          const chunks = await this.storefront(create, { input: { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/'+selection.id, quantity: selection.quantity }], buyerIdentity: { countryCode: 'BR' }, delivery: { addresses: [{ address: { deliveryAddress: { countryCode: 'BR', provinceCode, zip } }, selected: true, oneTimeUse: true }] } } });
          const result = chunks[0]?.data?.cartCreate;
          if (!result?.cart?.id || result.userErrors?.length || chunks.some(c => c.errors?.length)) throw new Error(this.dataset.failed);
          const query = 'query TakebagDeliveryQuote($id: ID!) { cart(id: $id) { ...TakebagDelivery @defer } } fragment TakebagDelivery on Cart { deliveryGroups(first: 10, withCarrierRates: true) { nodes { deliveryOptions { handle code title description estimatedCost { amount currencyCode } } } pageInfo { hasNextPage endCursor } } }';
          const parts = await this.storefront(query, { id: result.cart.id });
          if (parts.some(p => p.errors?.length || p.incremental?.some(i => i.errors?.length))) throw new Error(this.dataset.failed);
          let groups;
          for (const part of parts) { if (part.data?.cart?.deliveryGroups) groups = part.data.cart.deliveryGroups; for (const inc of part.incremental || []) if (inc.data?.deliveryGroups) groups = inc.data.deliveryGroups; }
          if (groups?.nodes?.length !== 1 || groups.pageInfo?.hasNextPage) throw new Error(this.dataset.failed);
          const rates = groups.nodes[0].deliveryOptions.filter(r => Number.isFinite(Number(r.estimatedCost?.amount)) && Number(r.estimatedCost.amount) >= 0).map(r => ({ handle:r.handle, code:r.code, name: r.title, description: r.description, price: Number(r.estimatedCost.amount), currency: r.estimatedCost.currencyCode }));
          if (!rates.length) throw new Error(this.dataset.failed);
          if (sequence !== this.sequence || key !== this.selectionKey()) return;
          const formatted = zip.slice(0,5)+'-'+zip.slice(5);
          this.show(rates, formatted);
          try { sessionStorage.setItem('takebag.delivery.product.v2', JSON.stringify({ at: Date.now(), key, zip: formatted, rates })); } catch (_) {}
        } catch (_) { if (sequence === this.sequence) this.status.textContent = this.dataset.failed; }
        finally { clearTimeout(timeout); if (sequence === this.sequence) { this.button.disabled = false; this.removeAttribute('aria-busy'); } }
      }
      show(rates, zip) {
        const formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', { style:'currency', currency:this.dataset.currency || 'BRL' });
        this.rates.replaceChildren();
        const lowest = Math.min(...rates.map(r => r.price));
        this.querySelector('[data-delivery-heading]').textContent = lowest === 0 ? this.dataset.freeLabel : this.dataset.from+' '+formatter.format(lowest);
        if (lowest === 0) this.dataset.free = 'true';
        this.status.textContent = this.dataset.for+' '+zip;
        this.displayedRates=rates;
        const choice = window.TakebagDelivery?.preference(zip.replace(/\D/g,''));
        const chosen=rates.find(rate=>window.TakebagDelivery?.match(rate,choice));
        if(chosen)this.querySelector('[data-delivery-heading]').textContent=chosen.name+' · '+(chosen.price===0?this.dataset.freeLabel:formatter.format(chosen.price));
        for (const rate of rates) {
          const li=document.createElement('li'),label=document.createElement('label'),radio=document.createElement('input'),name=document.createElement('span'),price=document.createElement('strong');
          radio.type='radio';radio.name='tb-product-rate-'+this.dataset.formId;radio.value=rate.handle;
          radio.checked=!!window.TakebagDelivery?.match(rate,choice);
          name.textContent=rate.name;price.textContent=rate.price===0?this.dataset.freeLabel:formatter.format(rate.price);
          label.className='tb-rate-choice';label.append(radio,name,price);li.append(label);li.dataset.selected=String(radio.checked);
          const timing=document.createElement('small');timing.className='tb-rate-time';timing.textContent=window.TakebagDelivery?.deliveryTiming(rate.description)||rate.description||this.dataset.checkoutTime;li.append(timing);
          radio.addEventListener('change',()=>{
            if(!window.TakebagDelivery)return;
            window.TakebagDelivery.choose(rate,zip.replace(/\D/g,''));
            this.rates.querySelectorAll('li').forEach(row=>row.dataset.selected=String(row.querySelector('input').checked));
            this.status.textContent=this.dataset.selected+' · CEP '+zip;
            this.querySelector('[data-delivery-heading]').textContent=rate.name+' · '+(rate.price===0?this.dataset.freeLabel:formatter.format(rate.price));
          });
          this.rates.append(li);
        }
        this.status.textContent=(chosen?this.dataset.selected:this.dataset.select)+' · CEP '+zip;
        this.rates.hidden = false;
        const digits = zip.replace(/\D/g,'');
        const destination = {zip:digits, province:this.province(digits)};
        const currentZip=digits;
        window.TakebagDelivery?.resolveAddress(destination).then(address=>{
          if(this.zip.value.replace(/\D/g,'')!==currentZip)return;
          const display=[address.address1,address.neighborhood,[address.city,address.province].filter(Boolean).join(' / ')].filter(Boolean).join(' · ');
          let summary=this.querySelector('[data-address-preview]');
          if(!summary){summary=document.createElement('p');summary.dataset.addressPreview='';summary.className='tb-delivery__note';this.rates.after(summary);}
          summary.textContent=display;
          try{sessionStorage.setItem('takebag.delivery.destination.v1',JSON.stringify(address));}catch(_){}
        });
        try { sessionStorage.setItem('takebag.delivery.destination.v1',JSON.stringify(destination)); } catch (_) {}
        document.dispatchEvent(new CustomEvent('takebag:destination-changed',{detail:{...destination,source:this}}));
      }
    }
    customElements.define('takebag-product-delivery', TakebagProductDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["takebag-shipping-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takebag-shipping-estimator')) {
  class TakebagShippingEstimator extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.sequence = 0;
      this.zip = this.querySelector('[data-zip]');
      this.button = this.querySelector('[data-calculate]');
      this.status = this.querySelector('[data-status]');
      this.rates = this.querySelector('[data-rates]');
      this.heading = this.querySelector('[data-heading]');
      this.destinationLabel = this.querySelector('[data-destination]');
      const options = {signal:this.events.signal};
      try {
        const saved = JSON.parse(sessionStorage.getItem('takebag.delivery.destination.v1') || 'null') || JSON.parse(sessionStorage.getItem('takebag.shipping.quote.v1') || 'null') || JSON.parse(sessionStorage.getItem('takebag.delivery.product.v2') || 'null');
        if (saved?.zip) this.zip.value = this.formatZip(saved.zip);
      } catch (_) {}
      this.zip.addEventListener('input', () => { this.zip.value = this.formatZip(this.zip.value); this.invalidate(); },options);
      this.zip.addEventListener('input',()=>{clearTimeout(this.autoZipTimer);if(this.zip.value.replace(/\D/g,'').length===8)this.autoZipTimer=setTimeout(()=>this.calculate(),450);},options);
      this.zip.addEventListener('keydown',event => { if (event.key === 'Enter') { event.preventDefault(); this.calculate(); } },options);
      this.button.addEventListener('click',() => this.calculate(),options);
      this.onCartChange = () => { this.invalidate(); this.queue(); };
      document.addEventListener('cart:updated',this.onCartChange,options);
      document.addEventListener('cart:refresh',this.onCartChange,options);
      document.addEventListener('takebag:destination-changed',event => {
        if (!event.detail || event.detail.source === this) return;
        const zip = event.detail.zip;
        if (zip === this.zip.value.replace(/\D/g,'') && (this.rates.childElementCount || this.button.disabled)) return;
        this.zip.value = this.formatZip(zip);
        this.invalidate();
        this.queue();
      },options);
      document.addEventListener('takebag:delivery-choice',()=>{this.invalidate();this.queue();},options);
      document.addEventListener('takebag:delivery-ready',()=>this.queue(),options);
      this.queue();
      if (location.hash === '#'+this.zip.id) this.querySelector('details').open = true;
    }
    disconnectedCallback() {
      clearTimeout(this.autoZipTimer);
      this.sequence++;
      clearTimeout(this.refreshTimer);
      this.controller?.abort();
      this.events?.abort();
      this.events = null;
    }
    formatZip(value) { const d=String(value).replace(/\D/g,'').slice(0,8); return d.length>5 ? d.slice(0,5)+'-'+d.slice(5) : d; }
    province(zip) {
      const n=Number(zip.slice(0,5));
      const ranges=[[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,72799,'DF'],[72800,72999,'GO'],[73000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
      return ranges.find(([a,b])=>n>=a&&n<=b)?.[2];
    }
    queue() {
      clearTimeout(this.refreshTimer);
      const zip=this.zip.value.replace(/\D/g,'');
      if (!/^\d{8}$/.test(zip) || !this.province(zip)) return;
      this.setSummary(this.dataset.summaryLoading,zip);
      this.refreshTimer=setTimeout(()=>{if(this.isConnected)this.calculate();},300);
    }
    invalidate() {
      this.querySelector('[data-address-preview]')?.remove();
      this.sequence++;
      clearTimeout(this.refreshTimer);
      this.controller?.abort();
      this.rates.replaceChildren();
      this.rates.hidden=true;
      this.button.disabled=false;
      this.status.textContent='';
      this.removeAttribute('aria-busy');
      this.setSummary(this.dataset.title);
    }
    setSummary(text,zip='') {
      this.querySelector('[data-delivery-date-summary]')?.remove();
      this.heading.textContent=text;
      this.destinationLabel.hidden=!zip;
      this.destinationLabel.textContent=zip ? this.dataset.zipLabel+' '+this.formatZip(zip)+' · '+this.dataset.changeZip : '';
    }
    fingerprint(cart) { return JSON.stringify({items:cart.items.map(item=>[item.key,item.quantity,item.final_line_price]),total:cart.total_price}); }
    async request(url,options={}) {
      const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'},signal:this.controller.signal,...options});
      if(!response.ok)throw new Error(this.dataset.failed);
      return response.json();
    }
    async calculate() {
      if(this.button.disabled || !window.TakebagDelivery)return;
      clearTimeout(this.refreshTimer);
      const zip=this.zip.value.replace(/\D/g,''),province=this.province(zip);
      if(!/^\d{8}$/.test(zip)||/^(\d)\1{7}$/.test(zip)||!province){this.status.textContent=this.dataset.invalidZip;this.zip.focus();return;}
      const sequence=++this.sequence;
      this.button.disabled=true;this.rates.replaceChildren();this.rates.hidden=true;
      this.setAttribute('aria-busy','true');this.status.textContent=this.dataset.loading;
      this.setSummary(this.dataset.summaryLoading,zip);
      const destination={zip,province};
      try{sessionStorage.setItem('takebag.delivery.destination.v1',JSON.stringify(destination));}catch(_){}
      document.dispatchEvent(new CustomEvent('takebag:destination-changed',{detail:{...destination,source:this}}));
      try{
        const quote=await window.TakebagDelivery.quote(destination);
        if(sequence!==this.sequence)return;
        if(!quote)throw new Error('empty');
        this.show(quote.rates,zip,quote.selected);
        const address=await window.TakebagDelivery.resolveAddress(destination);
        if(sequence!==this.sequence)return;
        const display=[address.address1,address.neighborhood,[address.city,address.province].filter(Boolean).join(' / ')].filter(Boolean).join(' · ');
        let summary=this.querySelector('[data-address-preview]');
        if(!summary){summary=document.createElement('p');summary.dataset.addressPreview='';summary.className='tb-shipping__note';this.rates.after(summary);}
        summary.textContent=display;
      }catch(error){
        if(sequence===this.sequence){
          if(error.message==='cart-changed'){this.invalidate();this.queue();return;}
          this.status.textContent=error.message==='empty'?this.dataset.empty:this.dataset.failed;
          this.setSummary(this.dataset.summaryFailed,zip);
        }
      }finally{if(sequence===this.sequence){this.button.disabled=false;this.removeAttribute('aria-busy');}}
    }
    show(rates,zip,selected){
      const formatter=new Intl.NumberFormat(this.dataset.locale||'pt-BR',{style:'currency',currency:this.dataset.currency||'BRL'});
      const chosen=rates.find(rate=>rate.handle===selected),lowest=Math.min(...rates.map(rate=>rate.price));
      const amount=rate=>rate.price===0?this.dataset.free:formatter.format(rate.price);
      this.setSummary(chosen?chosen.name+' · '+amount(chosen):lowest===0?this.dataset.free:this.dataset.summaryFrom+' '+formatter.format(lowest),zip);
      const dates=rates.map(rate=>window.TakebagDelivery?.deliveryTiming(rate.description)||rate.description||this.dataset.checkoutTime);
      const dateText=chosen ? window.TakebagDelivery?.deliveryTiming(chosen.description)||chosen.description||this.dataset.checkoutTime : dates.every(date=>date===dates[0]) ? dates[0] : '';
      if(dateText){const date=document.createElement('small');date.dataset.deliveryDateSummary='';date.textContent=dateText;date.style.cssText='font-size:12px;font-weight:600;color:#242424;margin-top:6px';this.heading.parentElement.append(date);}
      this.status.textContent=chosen?this.dataset.selected:this.dataset.select;
      this.rates.replaceChildren();
      for(const rate of rates){
        const row=document.createElement('li'),label=document.createElement('label'),radio=document.createElement('input'),name=document.createElement('span'),price=document.createElement('strong');
        radio.type='radio';radio.name='tb-cart-rate-'+this.zip.id;radio.value=rate.handle;radio.checked=rate.handle===selected;
        name.textContent=rate.name;price.textContent=amount(rate);label.className='tb-rate-choice';label.append(radio,name,price);
        row.dataset.selected=String(radio.checked);row.append(label);
        const timing=document.createElement('small');timing.className='tb-rate-time';timing.textContent=window.TakebagDelivery?.deliveryTiming(rate.description)||rate.description||this.dataset.checkoutTime;row.append(timing);
        radio.addEventListener('change',()=>window.TakebagDelivery.choose(rate,zip));
        this.rates.append(row);
      }
      this.rates.hidden=false;
    }
  }
  customElements.define('takebag-shipping-estimator',TakebagShippingEstimator);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["takebag-shipping-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takebag-shipping-notice')) {
    class TakebagShippingNotice extends HTMLElement {
      connectedCallback() {
        this.sequence = 0;
        this.events = new AbortController();
        this.restore = () => this.refresh();
        for (const event of ['takebag:shipping-quoted', 'cart:updated', 'cart:refresh', 'variant:changed']) {
          document.addEventListener(event, this.restore, { signal: this.events.signal });
        }
        document.addEventListener('change', this.restore, { signal: this.events.signal });
        this.refresh();
      }
      disconnectedCallback() { this.sequence++; this.events.abort(); }
      async refresh() {
        const sequence = ++this.sequence;
        this.querySelector('[data-shipping-heading]').textContent = this.dataset.defaultHeading;
        this.querySelector('[data-shipping-hint]').textContent = this.dataset.defaultHint;
        this.querySelector('[data-shipping-link]').textContent = this.dataset.defaultLink;
        this.removeAttribute('data-free');
        try {
          const saved = JSON.parse(sessionStorage.getItem('takebag.shipping.quote.v1') || 'null');
          if (!saved || Date.now() - saved.at > 300000) return;
          const response = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const fingerprint = JSON.stringify({ items: cart.items.map(item => [item.key, item.quantity, item.final_line_price]), total: cart.total_price });
          const form = document.getElementById(this.dataset.formId);
          const variant = form?.querySelector('[name="id"]')?.value || this.dataset.variantId;
          if (sequence !== this.sequence || fingerprint !== saved.fingerprint || !cart.items.some(item => String(item.product_id) === this.dataset.productId && String(item.variant_id) === String(variant))) return;
          const prices = saved.rates.map(rate => Number(rate.price)).filter(Number.isFinite);
          if (!prices.length) return;
          const lowest = Math.min(...prices);
          const zip = saved.zip.slice(0, 5) + '-' + saved.zip.slice(5);
          const formatter = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', { style: 'currency', currency: this.dataset.currency || 'BRL' });
          this.querySelector('[data-shipping-heading]').textContent = lowest === 0 ? this.dataset.freeConfirmed + ' ' + zip : this.dataset.shippingFrom + ' ' + formatter.format(lowest) + ' ' + this.dataset.forZip + ' ' + zip;
          this.querySelector('[data-shipping-hint]').textContent = this.dataset.cartEstimate;
          this.querySelector('[data-shipping-link]').textContent = this.dataset.changeZip;
          if (lowest === 0) this.dataset.free = 'true';
        } catch (_) {}
      }
    }
    customElements.define('takebag-shipping-notice', TakebagShippingNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
